import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/auth.guard';

export const routes: Routes = [
    {
        path: 'login',
        canActivate: [guestGuard],
        loadComponent: () => import('./pages/login/login-page').then((m) => m.LoginPage),
        title: 'Sign in – lighthouse-demo',
    },
    {
        path: '',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        loadComponent: () => import('./layout/shell').then((m) => m.Shell),
        children: [
            {
                path: '',
                loadComponent: () => import('./pages/player/player-page').then((m) => m.PlayerPage),
                title: 'lighthouse-demo',
            },
            {
                path: 'inbox',
                loadComponent: () => import('./pages/inbox/inbox-page').then((m) => m.InboxPage),
                title: 'Inbox – lighthouse-demo',
            },
            {
                path: 'environment',
                loadComponent: () =>
                    import('./pages/environment/environment-page').then((m) => m.EnvironmentPage),
                title: 'Environment – lighthouse-demo',
            },
        ],
    },
    { path: '**', redirectTo: '' },
];
